import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { getBlogBySlug } from '../services/getBlogBySlug.service'
import { blogsKeys } from '../constants/blogs.queryKeys'
import type { BlogPost } from '../types/blog.types'

export const blogDetailQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: blogsKeys.detail(slug || ''),
    queryFn: (): Promise<BlogPost> => getBlogBySlug(slug || ''),
  })

export function useBlog(slug: string) {
  return useSuspenseQuery(blogDetailQueryOptions(slug))
}
